import type { FC, ReactElement } from "react";

import { type ShareConfig } from "@ui/utils/share/share";

import { ReferralPersonalCodeVariantButton } from "./components/ReferralPersonalCodeVariantButton/ReferralPersonalCodeVariantButton";
import { ReferralPersonalCodeVariantIcon } from "./components/ReferralPersonalCodeVariantIcon/ReferralPersonalCodeVariantIcon";

import type { ReferralPersonalCodeIconPropsType } from "./ReferralPersonalCodeIcon";

export type ReferralPersonalCodePropsType = {
  topHeader?: string;
  code: string;
  header?: string;
  codeTitle?: string;
  shareTitle?: string;
  description?: string;
  variant?: "default" | "dashboard" | "withBackgroundImage";
  referralPageVariant?: boolean;
  items: ReferralPersonalCodeIconPropsType[];
  infoTitle?: string;
  smallText?: string;
  backgroundImage?: string;
  backgroundImageTablet?: string;
  backgroundImageMobile?: string;
  showCta?: boolean;
  ctaRow?: ReactElement;
  className?: string;
  withBottomCta?: boolean;
  bottomCtaLabel?: string;
  bottomCtaLink?: string;
  isHidden?: boolean;
  shareCodeVariant?: "shareIcons" | "shareButton";
  shareConfig?: ShareConfig;
  isLegacyStyled?: boolean;
};

export const ReferralPersonalCode: FC<ReferralPersonalCodePropsType> = (props: ReferralPersonalCodePropsType) => {
  const { isHidden, shareCodeVariant = "shareIcons" } = props;
  const showButtonVariant = shareCodeVariant === "shareButton";

  if (isHidden) {
    return null;
  }

  if (showButtonVariant) {
    return <ReferralPersonalCodeVariantButton {...props} />;
  }

  return <ReferralPersonalCodeVariantIcon {...props} />;
};
